import { register } from '@shopify/theme-sections'
import Swiper from 'swiper/bundle'
import 'slick-carousel'
import '../../styles/components/carousel.scss'
import '../../styles/sections/section-three-card-blogs.scss'

export default register(`section-three-card-blogs`, {
  onLoad() {
    new Swiper(`.custom-swiper-blogs`, {
        navigation: {
            nextEl: `.custom-slide-next`,
            prevEl: `.custom-slide-prev`,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                loop: true
            },
            768: {
                slidesPerView: 2,
                loop: true
            },
            950: {
                slidesPerView: 3
            }
        }
    })
  },
  onUnload() {
      
  },
})
